function LogoSection({ onHandleClickMenu, menu }) {
  return (
    <div onClick={() =>onHandleClickMenu(menu)}>
      <img src="/logo.svg" alt="Logo" className="h-10 hover:cursor-pointer" />
    </div>
  );
}

export default LogoSection;
